import type { MessageKey } from "./ru"

export const enMessages = {
  "common.loading": "Loading...",
  "common.error": "Error",
  "common.back": "Back",
  "common.next": "Next",
  "common.search": "Search",
  "auth.loginErrorTitle": "Sign-in error",
  "auth.openViaTelegram": "Open the app through Telegram",
  "auth.telegramRequired": "The app must be opened through Telegram",
  "auth.authorizationError": "Authorization error",
  "device.rotatePortrait": "Rotate your device to portrait mode",
  "country.brazil": "Brazil",
  "country.vietnam": "Vietnam",
  "country.egypt": "Egypt",
  "country.india": "India",
  "country.indonesia": "Indonesia",
  "country.iran": "Iran",
  "country.spain": "Spain",
  "country.italy": "Italy",
  "country.kazakhstan": "Kazakhstan",
  "country.colombia": "Colombia",
  "country.malaysia": "Malaysia",
  "country.mexico": "Mexico",
  "country.nigeria": "Nigeria",
  "country.pakistan": "Pakistan",
  "country.russia": "Russia",
  "country.usa": "United States",
  "country.turkey": "Türkiye",
  "country.uzbekistan": "Uzbekistan",
  "country.ukraine": "Ukraine",
  "country.philippines": "Philippines",
  "countrySelection.chooseCountry": "Choose a country",
  "countrySelection.openAria": "Choose a country",
  "languageSelection.chooseLanguage": "Choose a language",
  "commercial.direction.autotrade": "Auto Market",
  "commercial.direction.insurance": "Insurance",
  "commercial.direction.pitstop": "Pit Stop",
  "commercial.direction.techhelp": "Roadside Help",
  "commercial.searchLabel": "BeepApp search",
  "commercial.cityPlaceholder": "Enter city",
  "commercial.emptyTitle": "No offers today",
  "commercial.emptyLine1": "There are no active BeepApp partners in your city yet",
  "commercial.emptyLine2": "We are already working on finding and connecting them",
  "commercial.emptyLine3": "New offers will appear here automatically",
  "commercial.helperLine1": "Enter your city to see",
  "commercial.helperLine2": "available offers",
  "commercial.partnerPrompt": "Want to become a BeepApp partner?",
  "commercial.apply": "Apply",
  "main.admin": "Admin",
  "main.garage": "Garage",
  "main.signalSent": "Signal sent",
  "main.partnerInviteUnavailable": "Partner invitation unavailable",
  "main.enterPlate": "Enter license plate",
  "main.searchError": "Search error",
  "main.signalSendError": "Failed to send signal",
  "main.shareCardPrefix": "Plate card",
  "main.shareLinkError": "Could not prepare the link",
  "main.searchByPlateAria": "Search by license plate",
  "main.russianPlateAria": "Russian license plate",
  "main.plateAria": "License plate",
  "main.findPlateAria": "Find plate",
  "main.loadingVehicle": "Loading plate card…",
  "main.leaveSignal": "Send a signal",
  "main.share": "Share",
  "signalSelection.chooseType": "Choose signal type",
  "signalSelection.category.attention": "Personal",
  "signalSelection.category.road": "Road",
  "signalSelection.category.urgent": "Urgent",
  "signalSelection.chooseSignal": "Choose a signal",
  "signalSelection.suggestOwn": "Suggest your own",
  "signalConfirmation.title": "Confirm signal",
  "signalConfirmation.plateHeading": "Check the license plate",
  "signalConfirmation.signalHeading": "Check the selected signal",
  "signalConfirmation.replyTitle": "Allow reply in Telegram",
  "signalConfirmation.replyBody": "Enable this so the plate owner can\nmessage you in Telegram. Replies are possible only if\nyou have a @username. The decision to reply remains\nwith the plate owner.",
  "signalConfirmation.consentText": "I confirm that this signal reflects\na real situation and is not spam\nor a false report.",
  "signalConfirmation.warning": "After sending, the signal\ncannot be changed",
  "signalConfirmation.sending": "Sending…",
  "signalConfirmation.send": "Send",
  "partner.loadingAria": "Loading",
  "partner.title": "Partner Program",
  "partner.offerLine1": "Earn 30% from all payments indefinitely",
  "partner.offerLine2": "made by users you invite to BeepApp",
  "partner.offerLine3": "through the Telegram affiliate program",
  "partner.connectUnavailable": "Connection will become available after the Telegram Affiliate Program is configured.",
  "partner.connectTelegram": "Connect in Telegram",
  "partner.qrAria": "Partner link QR code",
  "partner.download": "Download",
  "partner.promoHeading": "Create a personal promo code",
  "partner.promoHelperLine1": "The promo code activates an extra subscription year",
  "partner.promoHelperLine2": "and helps attract users",
  "partner.promoAria": "Promo code",
  "partner.affiliateHeading": "Your affiliate link",
  "partner.affiliateHelper": "Save the link to create a personal QR code",
  "partner.affiliateAria": "Affiliate link",
  "partner.qrNoteLine1": "The QR code can be placed on your vehicle,",
  "partner.qrNoteLine2": "on social media and in advertising materials",
  "partner.save": "Save",
  "partner.reset": "Reset",
  "partner.resetConfirm": "Reset the saved affiliate link? The promo code will remain yours.",
  "partner.promoFormatError": "Promo code must contain 4 to 15 characters.",
  "partner.affiliateHostError": "Only t.me or telegram.me links are allowed.",
  "partner.affiliatePathError": "The link does not contain a Telegram path.",
  "partner.affiliateFormatError": "Invalid affiliate link.",
  "partner.loadError": "Load error",
  "partner.checkInputError": "Check the entered information",
  "garageActivation.promoInvalid": "Promo code is invalid",
  "garageActivation.plateOccupied": "This license plate is already linked",
  "garageActivation.activateError": "Could not activate Garage",
  "garageEntry.loadJournalError": "Could not load logbook",
  "garageEntry.loadStatusesError": "Could not load statuses",
  "garageEntry.activationSuccess": "Garage activated successfully",
  "garageEntry.plateAttached": "Plate linked",
  "garageEntry.attachError": "Could not link the plate",
  "garageEntry.activationNote": "Activate your Garage",
  "garageSheet.activationTitle": "Garage activation",
  "garageSheet.plateHelper": "Enter the vehicle license plate",
  "garageSheet.promoHelper": "Do you have a promo code?",
  "garageSheet.cleanBonusLine1": "After activation, you will have 1 hour",
  "garageSheet.cleanBonusLine2": "for a free “Clean Start”",
  "garageSheet.activationFor": "Activation for",
  "garageSheet.cost": "Cost",
  "garageSheet.ownerConsentLine1": "I confirm that I am the owner",
  "garageSheet.ownerConsentLine2": "of the vehicle with the specified",
  "garageSheet.ownerConsentLine3": "license plate.",
  "garageSheet.processing": "Processing...",
  "garageSheet.attach": "Link",
  "garageSheet.pay": "Pay",
  "garageLifecycle.cleanTitle": "Clean Start",
  "garageLifecycle.deactivateTitle": "Garage Deactivation",
  "garageLifecycle.cleanWarningLine1": "The plate history will be deleted",
  "garageLifecycle.cleanWarningLine2": "with no possibility of recovery!",
  "garageLifecycle.deactivateWarningLine1": "After deactivation, access to active",
  "garageLifecycle.deactivateWarningLine2": "Garage features will end",
  "garageLifecycle.willBeDeleted": "WILL BE DELETED",
  "garageLifecycle.cleanRemovedLine1": "• All entries from the Logbook",
  "garageLifecycle.cleanRemovedLine2": "• Received signal history",
  "garageLifecycle.cleanRemovedLine3": "• Public signal counters",
  "garageLifecycle.cleanRemovedLine4": "  on the plate card",
  "garageLifecycle.willRemain": "WILL REMAIN",
  "garageLifecycle.cleanPreservedLine1": "• Plate link to Garage",
  "garageLifecycle.cleanPreservedLine2": "• Remaining activation period",
  "garageLifecycle.cleanPreservedLine3": "• Selected plate status",
  "garageLifecycle.cleanPreservedLine4": "• Total plate-card view count",
  "garageLifecycle.freeFirstHour": "Free during the first hour",
  "garageLifecycle.willBecomeUnavailable": "WILL BECOME UNAVAILABLE",
  "garageLifecycle.deactivateRemovedLine1": "• Logbook",
  "garageLifecycle.deactivateRemovedLine2": "• Selecting and using plate status",
  "garageLifecycle.deactivateRemovedLine3": "• You will automatically leave AutoClan",
  "garageLifecycle.deactivateRemovedLine4": "• Auto Market",
  "garageLifecycle.deactivateRemovedLine5": "• Insurance",
  "garageLifecycle.deactivateRemovedLine6": "• Pit Stop",
  "garageLifecycle.deactivateRemovedLine7": "• Roadside Help",
  "garageLifecycle.deactivateRemovedLine8": "• License plate will be unlinked from Garage",
  "garageLifecycle.willRemainAvailable": "WILL REMAIN AVAILABLE",
  "garageLifecycle.deactivatePreservedLine1": "• Companion",
  "garageLifecycle.deactivatePreservedLine2": "• Dispatcher",
  "garageLifecycle.deactivatePreservedLine3": "• License-plate search and viewing",
  "garageLifecycle.deactivatePreservedLine4": "  the public vehicle card",
  "garageLifecycle.deactivatePreservedLine5": "• Ability to reactivate",
  "garageLifecycle.deactivatePreservedLine6": "  Garage at any time",
  "garageLifecycle.cleanConsentLine1": "I confirm consent to delete",
  "garageLifecycle.cleanConsentLine2": "the entire history of this plate",
  "garageLifecycle.cleanConsentLine3": "with no possibility of recovery.",
  "garageLifecycle.deactivateConsentLine1": "I confirm deactivation and",
  "garageLifecycle.deactivateConsentLine2": "termination of access to all",
  "garageLifecycle.deactivateConsentLine3": "active Garage features.",
  "garageLifecycle.clean": "Clear",
  "garageLifecycle.deactivate": "Deactivate",
} satisfies Record<MessageKey, string>
